import { render, staticRenderFns } from "./Jiayi.vue?vue&type=template&id=b2f86e6e&scoped=true"
import script from "./Jiayi.vue?vue&type=script&lang=js"
export * from "./Jiayi.vue?vue&type=script&lang=js"
import style0 from "./Jiayi.vue?vue&type=style&index=0&id=b2f86e6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f86e6e",
  null
  
)

export default component.exports